export default "/images/vendor/flag-icon-css/flags/4x3/us.svg?3cc0d38b3e8d93132c90fec5d3d06c68";